import React, { cloneElement } from 'react';
import { TopToolbar, sanitizeListRestProps, Button } from 'react-admin';

import AddIcon from '@material-ui/icons/Add';
import TimelineIcon from '@material-ui/icons/Timeline';

const ListActions = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter,
  filterValues,
  permanentFilter,
  hasCreate,
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  enabledCreate,
  handleCriar = () => {},
  handleDialogoDesconto = () => {},
  ...rest
}) => (
  <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
    {filters &&
      cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    <Button onClick={handleCriar} label="Novo">
      <AddIcon />
    </Button>
    <Button onClick={handleDialogoDesconto} label="Dialogo Desconto">
      <TimelineIcon />
    </Button>
  </TopToolbar>
);

export default ListActions;
